import { Routes, Route } from 'react-router-dom';
import {
    Home,
    Events,
    EventDetails,
    Organizations,
    OrgDetails,
    Billing,
    OrgEventsPage,
    MyTickets,
    MyProfile,
    Search,
    Recommendations, Privacy, Terms,
} from 'pages';
import { ORG_TYPES } from '../fragments';
import { ProfileInfo } from 'utils';

export const Routers = () => {
    const { token } = ProfileInfo();
    return (
        <div className='router-wrapper'>
            <Routes>
                <Route index path={'/'} element={<Home />} />
                <Route index path={'/events'} element={<Events />} />
                <Route index path={'/event/:id'} element={<EventDetails />} />
                <Route index path={'/nonProfits'} element={<Organizations type={ORG_TYPES.NON_PROFIT} />} />
                <Route index path={'/businesses'} element={<Organizations type={ORG_TYPES.BUSINESS} />} />
                <Route index path={'/organization/:id'} element={<OrgDetails />} />
                <Route index path={'/organization/:id/events'} element={<OrgEventsPage />} />

                {token && <Route index path={'/billing'} element={<Billing />} />}
                {token && <Route index path={'/tickets'} element={<MyTickets />} />}
                {token && <Route index path={'/profile'} element={<MyProfile />} />}


                <Route index path={'/search'} element={<Search />} />
                <Route index path={'/recommendations'} element={<Recommendations />} />
                <Route index path={'/privacy-policy'} element={<Privacy />} />
                <Route index path={'/term-condition'} element={<Terms />} />
                <Route path='*' element={<Home />} />
            </Routes>
        </div>
    );
};
